// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import VoiceAgentsFocus from '@app/features/konvo_assistant/voice/VoiceAgentsFocus';
import VoiceMode from '@app/features/konvo_assistant/voice/VoiceModeSession';

/**
 * Voice mode: one streamed sentence of the Assistant's reply, or the end of its turn. An event
 * with `focus` instead says what the answer is about (the Agents rows and cards to point at).
 */
export function handleKonvoAssistantVoice(data: unknown, _context: GatewayHandlerContext): void {
	if (!data || typeof data !== 'object') return;
	const event = data as {
		turn?: unknown;
		index?: unknown;
		text?: unknown;
		done?: unknown;
		ok?: unknown;
		focus?: unknown;
	};
	if (event.focus && typeof event.focus === 'object') {
		if (VoiceMode.active) VoiceAgentsFocus.receive((event.focus as {agents?: unknown}).agents);
		return;
	}
	VoiceMode.receiveSpeech({
		turn: typeof event.turn === 'string' ? event.turn : null,
		index: typeof event.index === 'number' ? event.index : 0,
		text: typeof event.text === 'string' ? event.text : undefined,
		done: event.done === true,
		ok: typeof event.ok === 'boolean' ? event.ok : undefined,
	});
}
